import { useTranslation } from "react-i18next";
import { getColor } from "../../../../pages/postEditor/seoAnalyzer/helper";

export const PlanAnlysis = ({ analysis }) => {
  const { t } = useTranslation();

  return (
    <>
      {/* Score bar */}
      <div className="mt-4">
                  <span className="font-semibold mb-3">
                    {analysis.total_score}%
                    </span>
                    </div>
                  
                  <div className="w-full relative p-2 rounded-xl bg-slate-300 mb-5 mt-1">
                    <div
                      className={`bg-${getColor(
                        analysis.total_score
                      )} h-full rounded-xl absolute top-0 left-0`}
                      style={{ width: `${analysis.total_score}%` }}
                    ></div>
                  </div>

      {/* Heading structure */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">
          {t("SEO-ANALYSIS-Heading-structure", "Structure des balises Hn")}
        </p>
        <p
          className={`${
            analysis?.checkHeadingStructure === 100
              ? "text-green-500"
              : analysis?.checkHeadingStructure === 0
              ? "text-red-600"
              : "text-gray_local-400"
          } text-sm mb-2 font-semibold`}
        >
          {analysis?.checkHeadingStructure === 100
            ? t(
                "SEO-ANALYSIS-Logical-order-perfect",
                "Toutes tes balises suivent un ordre logique."
              )
            : analysis?.checkHeadingStructure === 0
            ? t(
                "SEO-ANALYSIS-Non-logical-order",
                "Certaines de tes balises ne suivent pas un ordre logique."
              )
            : t("SEO-ANALYSIS-No-tags-found", "Aucune balise trouvée.")}
        </p>
      </div>

      {/* Hn Tag Length Check */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">
          {t("SEO-ANALYSIS-Hn-tags-length", "Longueur des balises Hn")}
        </p>
        <p
          className={`${
            analysis?.checkOptimalLength.percentage <= 10 &&
            analysis?.checkOptimalLength.percentage >= 0
              ? "text-green-500"
              : analysis?.checkOptimalLength.percentage > 10 &&
                analysis?.checkOptimalLength.percentage <= 20
              ? "text-yellow-400"
              : analysis?.checkOptimalLength.percentage > 20
              ? "text-red-600"
              : "text-gray_local-400"
          } text-sm mb-2 font-semibold`}
        >
          {analysis?.checkOptimalLength.percentage > 0 &&
            analysis?.checkOptimalLength.percentage <= 10 && (
              <>
                {t(
                  "SEO-ANALYSIS-Good-length-majority",
                  "Assez de tes balises Hn ont une bonne longueur ("
                )}
                {100 - analysis?.checkOptimalLength.percentage}%
                {t("SEO-ANALYSIS-Good-length-majority-end", ").")}
              </>
            )}

          {analysis?.checkOptimalLength.percentage === 0 &&
            t(
              "SEO-ANALYSIS-All-good-length",
              "Toutes tes balises Hn ont une bonne longueur."
            )}

          {analysis?.checkOptimalLength.percentage > 10 &&
            analysis?.checkOptimalLength.percentage <= 20 && (
              <>
                {analysis?.checkOptimalLength.tooShort > 0 ||
                analysis?.checkOptimalLength.tooLong > 0 ? (
                  <>
                    {t(
                      "SEO-ANALYSIS-Longer-or-shorter",
                      "Certaines de tes balises Hn sont trop longues ou trop courtes ("
                    )}
                    {analysis?.checkOptimalLength.percentage}%
                    {t("SEO-ANALYSIS-Longer-or-shorter-end", ").")}
                  </>
                ) : analysis?.checkOptimalLength.tooShort > 0 ? (
                  <>
                    {t(
                      "SEO-ANALYSIS-Too-short",
                      "Certaines de tes balises Hn ("
                    )}
                    {analysis?.checkOptimalLength.percentage}%
                    {t("SEO-ANALYSIS-Too-short-end", ") sont trop courtes.")}
                  </>
                ) : (
                  analysis?.checkOptimalLength.tooLong > 0 && (
                    <>
                      {t(
                        "SEO-ANALYSIS-Too-long",
                        "Certaines de tes balises Hn ("
                      )}
                      {analysis?.checkOptimalLength.percentage}%
                      {t("SEO-ANALYSIS-Too-long-end", ") sont trop longues.")}
                    </>
                  )
                )}
              </>
            )}

          {analysis?.checkOptimalLength.percentage > 20 && (
            <>
              {analysis?.checkOptimalLength.tooShort > 0 &&
              analysis?.checkOptimalLength.tooLong > 0 ? (
                <>
                  {t(
                    "SEO-ANALYSIS-Mostly-longer-or-shorter",
                    "Trop de tes balises Hn sont trop longues ou trop courtes ("
                  )}
                  {analysis?.checkOptimalLength.percentage}%
                  {t("SEO-ANALYSIS-Mostly-longer-or-shorter-end", ").")}
                </>
              ) : analysis?.checkOptimalLength.tooShort > 0 ? (
                <>
                  {t(
                    "SEO-ANALYSIS-Mostly-too-short",
                    "Trop de tes balises Hn ("
                  )}
                  {analysis?.checkOptimalLength.percentage}%
                  {t(
                    "SEO-ANALYSIS-Mostly-too-short-end",
                    ") sont trop courtes."
                  )}
                </>
              ) : (
                analysis?.checkOptimalLength.tooLong > 0 && (
                  <>
                    {t(
                      "SEO-ANALYSIS-Mostly-too-long",
                      "Trop de tes balises Hn ("
                    )}
                    {analysis?.checkOptimalLength.percentage}%
                    {t(
                      "SEO-ANALYSIS-Mostly-too-long-end",
                      ") sont trop longues."
                    )}
                  </>
                )
              )}
            </>
          )}

          {analysis?.checkOptimalLength.percentage === -1 &&
            t("SEO-ANALYSIS-No-tags-found", "Aucune balise trouvée.")}
        </p>
      </div>

      {/* Part Depth */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">
          {t("SEO-ANALYSIS-Part-depth", "Profondeur des sections")}
        </p>
        <p
          className={`${
            analysis?.checkPartDepth?.score === 100
              ? "text-green-500"
              : analysis?.checkPartDepth?.score === 50
              ? "text-yellow-400"
              : analysis?.checkPartDepth?.score === 0
              ? "text-red-600"
              : "text-gray_local-400"
          } text-sm mb-2 font-semibold`}
        >
          {analysis?.checkPartDepth?.score === 0 &&
            (analysis?.checkPartDepth.part_count_too_short >= 1 ||
            analysis?.checkPartDepth.part_count_too_long >= 2 ? (
              <>
                {t("SEO-ANALYSIS-Part-depth-bad", "Tu as")}
                {analysis?.checkPartDepth.part_count_too_short}
                {t(
                  "SEO-ANALYSIS-Part-depth-one-subpart",
                  "partie(s) avec une seule sous-partie"
                )}
                {t("SEO-ANALYSIS-Part-depth-and", "et")}
                {analysis?.checkPartDepth.part_count_too_long}
                {t(
                  "SEO-ANALYSIS-Part-depth-more-than-5",
                  "partie(s) avec plus de 5 sous-parties."
                )}
              </>
            ) : analysis?.checkPartDepth.part_count_too_short === 0 &&
              analysis?.checkPartDepth.part_count_too_long >= 2 ? (
              <>
                {t(
                  "SEO-ANALYSIS-Part-depth-too-many",
                  "Trop de tes parties ont plus de sous-parties que conseillé"
                )}
                {analysis?.checkPartDepth.part_count_too_long}
                {t("SEO-ANALYSIS-Part-depth-too-many-end", ".")}
              </>
            ) : analysis?.checkPartDepth.part_count_too_short >= 1 &&
              analysis?.checkPartDepth.part_count_too_long === 0 ? (
              <>
                {t("SEO-ANALYSIS-Part-depth-one-subpart-only", "Tu as")}
                {analysis?.checkPartDepth.part_count_too_short}
                {t(
                  "SEO-ANALYSIS-Part-depth-one-subpart",
                  "partie(s) avec une seule sous-partie."
                )}
              </>
            ) : null)}

          {analysis?.checkPartDepth?.score === 50 &&
            t(
              "SEO-ANALYSIS-Part-depth-middle",
              "Une de tes parties a plus de sous-parties que nécessaire."
            )}

          {analysis?.checkPartDepth?.score === 100 &&
            t(
              "SEO-ANALYSIS-Part-depth-good",
              "Toutes les parties ont une bonne profondeur."
            )}

          {analysis?.checkPartDepth?.score === -1 &&
            t("SEO-ANALYSIS-No-tags-found", "Aucune balise trouvée.")}
        </p>
      </div>

      {/* Repetition Check */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">
          {t(
            "SEO-ANALYSIS-Repetition-in-Hn-tags",
            "Répétition dans les balises Hn"
          )}
        </p>
        <p
          className={`${
            analysis?.checkSimilarity === 100
              ? "text-green-500"
              : analysis?.checkSimilarity === 0
              ? "text-red-600"
              : "text-gray_local-400"
          } text-sm mb-2 font-semibold`}
        >
          {analysis?.checkSimilarity === 100
            ? t(
                "SEO-ANALYSIS-No-repetition",
                "Aucune de tes balises Hn n'est répétée."
              )
            : analysis?.checkSimilarity === 0
            ? t(
                "SEO-ANALYSIS-Some-repetition",
                "Certaines de vos balises Hn contiennent des répétitions."
              )
            : t("SEO-ANALYSIS-No-tags-found", "Aucune balise trouvée.")}
        </p>
      </div>

      {/* Hn Count */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">
          {t("SEO-ANALYSIS-Number-of-heading-tagCount", "Nombre de balises Hn")}
        </p>
        <p
          className={`${
            analysis?.checkPartCount?.score > 75
              ? "text-green-500"
              : analysis?.checkPartCount?.score > 50
              ? "text-yellow-400"
              : analysis?.checkPartCount?.score >= 0
              ? "text-red-600"
              : "text-gray_local-400"
          } text-sm mb-2 font-semibold`}
        >
          {analysis?.hTags.length === 0 ? (
            t("SEO-ANALYSIS-No-tags-found", "Aucune balise trouvée.")
          ) : (
            <>
              {t("SEO-ANALYSIS-Outline-heading-tags", "Ton plan contient")}{" "}
              {analysis?.hTags.length}{" "}
              {t("SEO-ANALYSIS-heading-tags", "balises Hn ")} (
              {Object.entries(analysis)
                .filter(
                  ([key, value]) =>
                    key.startsWith("h") && key.endsWith("_count") && value > 0
                )
                ?.map(
                  ([key, value]) =>
                    `${value} ${
                      (key.toUpperCase().replace("_COUNT", ""),
                      key.toUpperCase().replace("_COUNT", ""))
                    }`
                )
                .join(", ")
                .replace(/,([^,]*)$/, t("SEO-ANALYSIS-and", " et") + "$1")}
              ),{" "}
              {analysis?.checkPartCount?.status === "perfect"
                ? t(
                    "SEO-ANALYSIS-Hn-count-perfect",
                    "ce qui est idéal pour un nombre de mots cible de"
                  )
                : analysis?.checkPartCount?.score <= 50 &&
                  analysis?.checkPartCount?.status === "too_few"
                ? t(
                    "SEO-ANALYSIS-Hn-count-insufficient",
                    "ce qui est insuffisant pour un nombre de mots cible de"
                  )
                : analysis?.checkPartCount?.score <= 50 &&
                  analysis?.checkPartCount?.status === "too_many"
                ? t(
                    "SEO-ANALYSIS-Hn-count-too-much",
                    "ce qui est trop pour un nombre de mots cible de"
                  )
                : analysis?.checkPartCount?.score > 50 &&
                  analysis?.checkPartCount?.status === "too_few"
                ? t(
                    "SEO-ANALYSIS-Hn-count-bit-insufficient",
                    "ce qui est un peu insuffisant pour un nombre de mots cible de"
                  )
                : analysis?.checkPartCount?.score > 50 &&
                  analysis?.checkPartCount?.status === "too_many"
                ? t(
                    "SEO-ANALYSIS-Hn-count-bit-too-much",
                    "ce qui est un peu trop pour un nombre de mots cible de"
                  )
                : t(
                    "SEO-ANALYSIS-for-a-target-word-count-of",
                    "pour un nombre de mots cible de"
                  )}{" "}
              {analysis.nb_words} {t("words", "mots")}.
            </>
          )}
        </p>
      </div>
    </>
  );
};
